var map = {
	"./favicon.ico": 244,
	"./folk_logo": 34,
	"./folk_logo.png": 34,
	"./logo-black": 31,
	"./logo-black.png": 31,
	"./logo-white": 192,
	"./logo-white.png": 192,
	"./no-image": 9,
	"./no-image-thumb": 193,
	"./no-image-thumb.jpg": 193,
	"./no-image.jpg": 9,
	"./sp-hd-sign-in-logo": 19,
	"./sp-hd-sign-in-logo.png": 19,
	"./sp-hd-sign-up-logo": 20,
	"./sp-hd-sign-up-logo.png": 20,
	"./sp_preview": 194,
	"./sp_preview.png": 194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;